import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { AddMaterial, AddMaterialDefaultValues } from 'src/app/components/materials/materials';
import { FileService } from 'src/app/services/file.service';
import { MaterialsService } from 'src/app/services/materials.service';
import { TagsService } from 'src/app/services/tag-service.service';
import { ToastService } from 'src/app/services/toast-service.service';


@Component({
    selector: 'app-add-material',
    templateUrl: './add-material.component.html',
    styleUrls: ['./add-material.component.scss'],
    standalone: false
})
export class AddMaterialComponent implements OnInit {
  selectedFile: File | null = null;
  tags: any[] = [];
  material:AddMaterial=AddMaterialDefaultValues();
  hideReviewPanel:boolean=true;
  materialTypes:any[]=[]
  selectedTags:any[]=[]
  materialStatus:any[]=[]
  materialLanguage:any[]=[];
  selectedFileName:string='Drag and drop your file here or click to upload '
  isSubmitted:boolean=false;
  uploadedFileName:string=''
  isUploading:boolean=false;
  isSaving:boolean=false;
  uploadProgress:number=0;
  isUploadComplete:boolean=false;
  pageName = CheckPageAccess.ADDMATERIAL

  constructor(private tagservice: TagsService,
    private materialservice:MaterialsService,
    private fileservice:FileService,
    private toastservice:ToastService,
    private router:Router
  ) { }

  ngOnInit(): void {
    this.materialTypes=this.materialservice.getMaterialTypes();
     this.materialservice.getMaterialLanguages().subscribe({
      next: (data) => {this.materialLanguage = data}
    });
     this.tagservice.getActiveTags().subscribe({
      next:(resp)=>{
        this.tags = resp
      }
    })
    console.log(this.tags)
     this.materialservice.getMaterialStatus("ADD").subscribe({
      next:(resp)=>{this.materialStatus = resp}
    })
  }

  onSelect(event: NgxDropzoneChangeEvent) {
    this.selectedFileName=''
    
    const file = event.addedFiles[0]; // Get the first file selected

    if (file) {
      this.selectedFileName=file.name;
      const formData = new FormData();
      formData.append('file', file);
      this.isUploading = true;
      this.isUploadComplete = false;
      this.uploadProgress = 0;
      this.fileservice.uploadMaterialFile(formData, this.material.materialType).subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            // Keep under 100% until the server finishes and returns a response
            this.uploadProgress = Math.min(99, Math.round((100 * event.loaded) / event.total));
          } else if (event.type === HttpEventType.Response) {
            this.material.materialFileId = event.body.id;
            this.uploadedFileName = event.body.fileName;
            this.uploadProgress = 100;
            this.isUploadComplete = true;
            setTimeout(() => {
              this.isUploading = false;
              this.isUploadComplete = false;
            }, 1500);
          }
        },
        error: () => {
          this.isUploading = false;
          this.isUploadComplete = false;
          this.uploadProgress = 0;
          this.selectedFileName = 'Drag and drop your file here or click to upload ';
          this.toastservice.showErrorMessage('File upload failed. Please try again.');
        }
      })     
    }
  }
 
 
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit(form:NgForm) {
    console.log(this.material.materialType)
    this.isSubmitted=true;
    this.material.tags = this.selectedTags
    if(!this.validateReqFileds(form))
    {
      
      this.toastservice.showErrorMessage('Please fill all the required fields')
      return;
    }
    if (this.isUploading || this.isSaving) {
      return;
    }
    this.isSaving = true;
    this.materialservice.createMaterial(this.material).subscribe({
    next: (resp) => 
        {
            this.isSaving = false;
            this.toastservice.showMessage("Material Created Successfully")
            this.router.navigate(['/material-list'])
        },
    error: () => {
            this.isSaving = false;
            this.toastservice.showErrorMessage('Failed to create material. Please try again.');
        }
    })
  }

  getTagName(id: string): string {
    const tag = this.tags.find(t => t.id === id);
    return tag ? tag.tagName : '';
  }

  validateReqFileds(form:NgForm):boolean{
   
    var validated = true;
    if(this.material.materialName==null || this.material.materialName==''){
      validated=false
    }
    if(this.material.materialType==null || this.material.materialType==0){
      validated=false 
    }
    if(this.material.materialFileId==null || this.material.materialFileId==0){
    validated=false
    }
    if(this.material.language==null || this.material.language==0){
      validated=false
    }
   
    if(this.material.status==0)
    {
      validated=false 
    }

    return validated;
  }

  downloadFile(){
    this.fileservice.downloadMaterialFile(this.material.materialFileId).subscribe({
      next:(response) => {
        window.open(response.url, '_blank');
      }
    })
  }

  removeMaterialFile()
  {
    this.uploadedFileName=''
    this.material.materialFileId = 0;
    this.isUploadComplete = false;
    this.uploadProgress = 0;
  }
}
